/**
 * A propensity score as a whole percent. The API sends a fraction, and `* 100` alone
 * misses an exact comparison (`0.57 * 100` is 56.99999999999999), as does a stored
 * 0.7000000000000001. Kept apart from
 * the chart so pages can use it without importing Chart.js.
 */
export const scorePercent = (score) => Math.round(Number(score) * 100);
